import type { IPexelVideo, IPexelVideoFile } from "@/shared/types";
import type { IVideosPanelVideo } from "../types";

interface IProps {
  videos: IPexelVideo[];
  extend?: boolean;
}

export const videosPanelPexelVideosToCols = ({ videos, extend }: IProps) => {
  return (prev: IVideosPanelVideo[][]) => {
    const vids: IVideosPanelVideo[] = videos.map((vid) => ({
      id: vid.id,
      url: getPexelsVideoFile(vid).link,
      width: vid.width,
      height: vid.height,
      thumbnailImage: getPexelsVideoThumbnail(vid),
      thumbnailVideo: getPexelsVideoFile(vid, "thumbnail").link,
    }));

    if (extend) {
      const currentColumns: IVideosPanelVideo[][] = [
        [...prev[0]],
        [...prev[1]],
        [...prev[2]],
      ];
      vids.forEach((vid, index) => {
        const totalItems = prev.reduce((sum, col) => sum + col.length, 0);
        const columnIndex = (totalItems + index) % 3;
        currentColumns[columnIndex].push(vid);
      });
      return currentColumns;
    }

    const newColumns: IVideosPanelVideo[][] = [[], [], []];
    vids.forEach((vid, index) => {
      const columnIndex = index % 3;
      newColumns[columnIndex].push(vid);
    });
    return newColumns;
  };
};

export const getPexelsVideoFile = (
  item: IPexelVideo,
  type: "thumbnail" | "video" = "video",
): IPexelVideoFile => {
  if (type === "thumbnail") {
    // For thumbnail, get the smallest video file by size
    const sortedFiles = [...item.video_files].sort((a, b) => a.size - b.size);
    return sortedFiles[0];
  }

  // For video, get the largest available video file
  let file = item.video_files.find((f) => f.width === 1280);
  if (!file) file = item.video_files.find((f) => f.width === 960);
  if (!file) file = item.video_files.find((f) => f.width === 720);
  if (!file) file = item.video_files.find((f) => f.width === 640);
  if (!file) file = item.video_files[0];
  return file;
};

export const getPexelsVideoThumbnail = (item: IPexelVideo) => {
  return item.image;
};
